import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';

const VideoProgressBar = (props) => {
  const { progress, isUnassigned = false, active } = props;
  const {
    not_started: notStarted,
    started,
    watched,
    total_students: totalStudents,
  } = progress;
  const notStartedPercentage = (notStarted / totalStudents) * 100;
  const startedPercentage = (started / totalStudents) * 100;
  const watchedPercentage = (watched / totalStudents) * 100;

  const getBarStyle = (value) => {
    let classNames = 'flex justify-center items-center px-6';
    return value === totalStudents ? `${classNames} rounded-full` : classNames;
  };

  const barClasses = cn(
    isUnassigned ? 'w-0' : 'w-80',
    'flex h-10 bg-gray-400 rounded-full',
    {
      'cursor-pointer': active,
    },
  );

  if (totalStudents < 1) {
    return (
      <div className={barClasses}>
        {
          <span
            className={`text-black bg-gray-400 rounded-l-full ${getBarStyle(
              notStarted,
            )}`}
            style={{ width: `${100}%` }}
          >
            {0}
          </span>
        }
      </div>
    );
  }

  return (
    <div className={barClasses}>
      {notStarted > 0 && (
        <span
          className={`text-black bg-gray-400 rounded-l-full ${getBarStyle(
            notStarted,
          )}`}
          style={{ width: `${notStartedPercentage}%` }}
        >
          {notStarted}
        </span>
      )}
      {started > 0 && (
        <span
          className={cn(`text-purple-700 bg-pink-200 ${getBarStyle(started)}`, {
            'rounded-r-full': watched === 0,
            'rounded-l-full': notStarted === 0,
          })}
          style={{ width: `${startedPercentage}%` }}
        >
          {started}
        </span>
      )}
      {watched > 0 && (
        <span
          className={`text-pink-200 bg-purple-700 rounded-r-full ${getBarStyle(
            watched,
          )}`}
          style={{ width: `${watchedPercentage}%` }}
        >
          {watched}
        </span>
      )}
    </div>
  );
};

VideoProgressBar.displayName = 'VideoProgressBar';
VideoProgressBar.defaultProps = {
  progress: {},
};
VideoProgressBar.propTypes = {
  progress: PropTypes.shape({
    not_started: PropTypes.number,
    started: PropTypes.number,
    watched: PropTypes.number,
    total_students: PropTypes.number,
  }),
};
export default VideoProgressBar;
